<template>
  <div class="home">
    <div class="wb" v-loading="wbLoading">
      <!-- 经营概览 -->
      <div class="wb-overview">
        <div
          v-for="c in overviewCards"
          :key="c.key"
          class="ov-card"
          :class="{ clickable: c.to || c.action }"
          @click="onOverview(c)"
        >
          <div class="ov-value" :class="c.tone">{{ c.value }}</div>
          <div class="ov-label">{{ c.label }}</div>
        </div>
      </div>

      <el-row :gutter="12" class="wb-row">
        <el-col :span="12">
          <div class="wb-card">
            <div class="wb-card-head">
              <span>待我关注</span>
              <span class="wb-sub">审批 / 客服积压</span>
            </div>
            <div class="todo-list">
              <div
                v-for="t in approvalItems"
                :key="t.key"
                class="todo-item"
                @click="go(t.to)"
              >
                <span class="todo-name">{{ t.label }}</span>
                <span class="todo-count" :class="{ zero: !t.value }">{{ t.value }}</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="wb-card">
            <div class="wb-card-head">
              <span>施工态势</span>
              <el-radio-group v-model="siteView" size="mini">
                <el-radio-button label="today">今日开工 {{ site.todayStartCount || 0 }}</el-radio-button>
                <el-radio-button label="doing">进行中 {{ site.doingCount || 0 }}</el-radio-button>
                <el-radio-button label="delayed">延期 {{ site.delayedCount || 0 }}</el-radio-button>
              </el-radio-group>
            </div>
            <div class="stage-list">
              <div v-if="!currentStageList.length" class="wb-empty">暂无数据</div>
              <div
                v-for="(s, i) in currentStageList"
                :key="i"
                class="stage-item"
                @click="goStageDetail(s)"
              >
                <div class="stage-main">
                  <span class="stage-proj">{{ s.name || s.customerName || s.projectName || '-' }}</span>
                  <el-tag v-if="s.deferred" size="mini" type="danger">延期</el-tag>
                </div>
                <div class="stage-sub">
                  {{ s.stageName || '-' }} · {{ s.workerName || '未排工' }} · {{ fmtRange(s.planStart, s.planEnd) }}
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="wb-card">
        <div class="wb-card-head">
          <span>材料 · 人工履约</span>
        </div>
        <div class="supply-grid">
          <div
            v-for="c in supplyCards"
            :key="c.key"
            class="supply-cell"
            @click="go(c.to)"
          >
            <div class="supply-value">{{ c.value }}</div>
            <div class="supply-label">{{ c.label }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdminDashboard } from '../api/project'

export default {
  name: 'Home',
  data() {
    return {
      wbLoading: false,
      siteView: 'today',
      overview: {},
      approvals: {},
      site: {},
      supply: {}
    }
  },
  computed: {
    overviewCards() {
      const o = this.overview || {}
      return [
        { key: 'total', label: '总项目数', value: o.totalProjectCount || 0, to: { path: '/project' } },
        { key: 'inProgress', label: '在建项目', value: o.inProgressProjectCount || 0, to: { path: '/project', query: { status: 'IN_PROGRESS' } } },
        { key: 'monthNew', label: '本月新开', value: o.monthNewProjectCount || 0, to: { path: '/project' } },
        { key: 'defer', label: '延期工序', value: o.deferredStageCount || 0, tone: 'danger', action: 'delayed' },
        { key: 'after', label: '待处理售后', value: o.openAfterSaleCount || 0, tone: 'danger', to: { path: '/service/after-sale', query: { status: 'PENDING' } } }
      ]
    },
    approvalItems() {
      const a = this.approvals || {}
      return [
        { key: 'mreq', label: '材料申请待审', value: a.materialReqSubmitted || 0, to: { path: '/material/requisition', query: { status: 'SUBMITTED' } } },
        { key: 'lreq', label: '工资待审', value: a.laborReqSubmitted || 0, to: { path: '/labor/requisition', query: { status: 'SUBMITTED' } } },
        { key: 'mret', label: '材料退货待审', value: a.materialReturnSubmitted || 0, to: { path: '/material/return', query: { status: 'SUBMITTED' } } },
        { key: 'after', label: '售后待处理', value: a.afterSaleOpen || 0, to: { path: '/service/after-sale', query: { status: 'PENDING' } } },
        { key: 'suggest', label: '投诉建议待处理', value: a.suggestOpen || 0, to: { path: '/service/suggest', query: { status: 'PENDING' } } }
      ]
    },
    supplyCards() {
      const s = this.supply || {}
      return [
        { key: 'pd', label: '待供货申请', value: s.pendingDeliveryReqCount || 0, to: { path: '/material/requisition', query: { status: 'APPROVED', receiveStatus: 'NONE' } } },
        { key: 'pr', label: '部分收货', value: s.partialReceiveCount || 0, to: { path: '/material/requisition', query: { status: 'APPROVED', receiveStatus: 'PARTIAL' } } },
        { key: 'lu', label: '人工已审未发', value: s.laborApprovedUnpaidCount || 0, to: { path: '/labor/requisition', query: { status: 'APPROVED', payStatus: 'UNPAID' } } },
        { key: 'lc', label: '已发未确认', value: s.laborPaidUnconfirmedCount || 0, to: { path: '/labor/requisition', query: { status: 'APPROVED', payStatus: 'ISSUED', confirmStatus: 'UNCONFIRMED' } } }
      ]
    },
    currentStageList() {
      const s = this.site || {}
      if (this.siteView === 'doing') return s.doingStages || []
      if (this.siteView === 'delayed') return s.delayedStages || []
      return s.todayStartStages || []
    }
  },
  created() {
    this.loadDashboard()
  },
  methods: {
    async loadDashboard() {
      this.wbLoading = true
      try {
        const res = await getAdminDashboard()
        const d = res.data || {}
        this.overview = d.overview || {}
        this.approvals = d.approvals || {}
        this.site = d.site || {}
        this.supply = d.supply || {}
      } finally {
        this.wbLoading = false
      }
    },
    onOverview(c) {
      if (c.action === 'delayed') {
        this.siteView = 'delayed'
        return
      }
      this.go(c.to)
    },
    go(to) {
      if (!to) return
      this.$router.push(to).catch(() => {})
    },
    goStageDetail(row) {
      const stageId = row && (row.id != null ? row.id : row.stageId)
      if (stageId == null || stageId === '') {
        this.$message.warning('缺少计划信息，请刷新后重试')
        return
      }
      this.$router.push({
        path: '/project/stages/detail',
        query: { id: String(stageId) }
      }).catch(() => {})
    },
    fmtDate(v) {
      if (!v) return '-'
      return String(v).slice(0, 10)
    },
    fmtRange(start, end) {
      if (!start && !end) return '-'
      return this.fmtDate(start) + ' 至 ' + this.fmtDate(end)
    }
  }
}
</script>

<style scoped>
.home {
  max-width: 1100px;
}

.wb {
  padding-top: 4px;
}
.wb-overview {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.ov-card {
  flex: 1;
  min-width: 150px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 18px;
}
.ov-card.clickable {
  cursor: pointer;
  transition: box-shadow 0.15s, border-color 0.15s;
}
.ov-card.clickable:hover {
  border-color: #93c5fd;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.1);
}
.ov-value {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
}
.ov-value.warn {
  color: #d97706;
}
.ov-value.danger {
  color: #dc2626;
}
.ov-label {
  margin-top: 6px;
  color: #64748b;
  font-size: 13px;
}

.wb-row {
  margin-bottom: 14px;
}
.wb-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 18px 16px;
  margin-bottom: 14px;
  height: 100%;
  box-sizing: border-box;
}
.wb-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 12px;
}
.wb-sub {
  font-size: 12px;
  font-weight: 400;
  color: #94a3b8;
}

.todo-list {
  display: flex;
  flex-direction: column;
}
.todo-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 6px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
}
.todo-item:last-child {
  border-bottom: none;
}
.todo-item:hover {
  background: #f8fafc;
}
.todo-name {
  color: #334155;
  font-size: 14px;
}
.todo-count {
  min-width: 26px;
  height: 22px;
  padding: 0 8px;
  border-radius: 11px;
  background: #ef4444;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.todo-count.zero {
  background: #e2e8f0;
  color: #94a3b8;
}

.stage-list {
  display: flex;
  flex-direction: column;
}
.stage-item {
  padding: 9px 6px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
}
.stage-item:last-child {
  border-bottom: none;
}
.stage-item:hover {
  background: #f8fafc;
}
.stage-main {
  display: flex;
  align-items: center;
  gap: 8px;
}
.stage-proj {
  color: #0f172a;
  font-size: 14px;
  font-weight: 500;
}
.stage-sub {
  margin-top: 3px;
  color: #94a3b8;
  font-size: 12px;
}
.wb-empty {
  padding: 28px 0;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}

.supply-grid {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.supply-cell {
  flex: 1;
  min-width: 150px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  padding: 14px 16px;
  cursor: pointer;
  transition: border-color 0.15s;
}
.supply-cell:hover {
  border-color: #93c5fd;
}
.supply-value {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
}
.supply-label {
  margin-top: 4px;
  color: #64748b;
  font-size: 13px;
}
</style>
